import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCustomer,
  getNext,
  getPrevious,
  getParticularPage,
  getCustomerById,
  createCustomer,
  updateCustomer,
  handleSearch,
} from "./thunk";

const initialState = {
  customers: [],
  edit: false,
  customer: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingCustomer: false,
  loadingNext: false,
  contactDetails: [],
  billToDetails: [],
  shipToDetails: [],
  documents: [],
  showCreateModal: false,
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    contactDetailsUpdate: (state, action) => {
      state.contactDetails = action.payload;
    },
    billToDetailsUpdate: (state, action) => {
      state.billToDetails = action.payload;
    },
    shipToDetailsUpdate: (state, action) => {
      state.shipToDetails = action.payload;
    },
    documentsUpdate: (state, action) => {
      state.documents = action.payload;
    },

    revertToPreviousState: (state) => {
      state.contactDetails = state.contactDetails.filter((value) => value.id !== undefined && value.id !== null);
      state.billToDetails = state.billToDetails.filter((value) => value.id !== undefined && value.id !== null);
      state.shipToDetails = state.shipToDetails.filter((value) => value.id !== undefined && value.id !== null);
      state.documents = state.documents.filter((value) => value.id !== undefined && value.id !== null);
    },
    clearAllCustomer: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCustomer = false;
      state.customer = null;
      state.contactDetails = [];
      state.billToDetails = [];
      state.shipToDetails = [];
      state.documents = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomerById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.customer = action.payload.data;
      state.contactDetails = action.payload.data.customerMasterContactDetails;
      state.billToDetails = action.payload.data.billToDetailsCustomerMaster;
      state.shipToDetails = action.payload.data.shipToDetails;
      state.documents = action.payload.data.customerMasterDocuments;
    });
    builder.addCase(getCustomerById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCustomer.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createCustomer.fulfilled, (state, action) => {
      state.loadingCreate = false;
      state.edit = false;
    });
    builder.addCase(createCustomer.rejected, (state) => {
      state.loadingCreate = false;
      state.edit = false;
    });
    builder.addCase(updateCustomer.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCustomer.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCustomer.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCustomer.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCustomer = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCustomer.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCustomer = false;
        state.customers = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCustomer.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCustomer = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  customerEdit,
  contactDetailsUpdate,
  billToDetailsUpdate,
  shipToDetailsUpdate,
  documentsUpdate,
  revertToPreviousState,
  clearAllCustomer,
} = customerSlice.actions;

export default customerSlice.reducer;
